// extracted by extract-css-chunks-webpack-plugin
module.exports = {"video_box":"video_box-2V-K_9HS","video":"video-1pwNgO-e"};